import React, { useState, useEffect, useCallback } from 'react'

// redux
import { connect } from 'react-redux'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'

// react router
import { useHistory } from 'react-router-dom'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// api
import {
    cancelGetOrderPaymentStatusListApi,
    cancelGetOrderStatusListApi,
    getOrderDetails,
    getOrderPaymentStatusList,
    getOrderStatusList,
    updateOrderStatus,
    updatePaymentStatus
} from 'utlis/Apis/SaleOrder_API'

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    ERROR_WHILE_GETTING_ORDER_DETAILS
} from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'

// page components
import ProductsView from './Includes/PageComponents/ProductsView'
import AddTrackingNumberModal from './Includes/Modal/AddTrackingNumberModal'
import AddNote from './Includes/PageComponents/AddNote'
import AdditionalInformation from './Includes/PageComponents/AdditionalInformation'
import PaymentInformation from './Includes/PageComponents/PaymentInformation'


function EditSaleOrder(props) {
    // props
    const {
        setGlobalLoading,

        match,

        commonToken,
    } = props

    // consts
    const history = useHistory()

    // states
    const [currentOrderId, setCurrentOrderId] = useState(null)
    const [orderDetails, setOrderDetails] = useState({})
    const [pageLoading, setPageLoading] = useState(false)

    // dropdowns
    const [orderUpdateDropdown, setOrderUpdateDropdown] = useState(false)
    const [paymentStatusDropdown, setPaymentStatusDropdown] = useState(false)
    const [fullfillmentStatusDropdown, setFullfillmentStatusDropdown] = useState(false)

    const [addNoteViewVisibility, setAddNoteViewVisibility] = useState(false)

    const [orderStatusList, setOrderStatusList] = useState([])
    const [paymentStatusList, setPaymentStatusList] = useState([])

    const [currentOrderStatus, setCurrentOrderStatus] = useState("")
    const [currentPaymentStatus, setCurrentPaymentStatus] = useState("")

    const [trackingModalVisibility, setTrackingModalVisibility] = useState(false)
    const [selectedTrackingNumber, setSelectedTrackingNumber] = useState("")

    // checking current order Id
    useEffect(() => {
        if (match?.params?.id) {
            // setting global loading
            setGlobalLoading(true)

            // setting current route
            setCurrentOrderId(match.params.id)

            // setting global loading
            setGlobalLoading(false)
        }
    }, [match.params.id, setGlobalLoading])

    // funcion for getting order detals
    const getOrderDetailsFunction = useCallback(() => {
        if (currentOrderId) {
            // global loading
            setGlobalLoading(true)

            // getting data
            getOrderDetails(commonToken, currentOrderId).then(res => {
                const resData = res.data

                console.log("resData ", resData);

                // global loading
                setGlobalLoading(false)

                // if success
                if (resData.success) {
                    setOrderDetails({
                        images: resData.images,
                        notes: resData.notes,
                        orders: resData.order,
                        orderItems: resData.order_items,
                        payments: resData.payments,
                    }) // setting all orders data
                }

                // if error
                if (resData.error) {
                    console.log(`${ERROR_WHILE__NAME} getOrderDetails `, resData.message);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? ERROR_WHILE_GETTING_ORDER_DETAILS, {
                        autoClose: 2500
                    });
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getOrderDetails `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)
                    },
                });
            })
        }
    }, [currentOrderId, setGlobalLoading, commonToken])

    // getting data according to order id
    useEffect(() => {
        getOrderDetailsFunction()
    }, [getOrderDetailsFunction])

    useEffect(() => {
        if (commonToken) {
            Promise.all([
                getOrderStatusList(commonToken),
                getOrderPaymentStatusList(commonToken),
            ]).then(res => {
                // order status
                (function () {
                    const resData = res[0]?.data

                    // if request is success
                    if (resData?.success) {
                        setOrderStatusList(resData?.data) // setting status data
                    }

                    // if request is error
                    if (resData?.error) {
                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500
                        });
                    }
                })();

                // payment status
                (function () {
                    const resData = res[1]?.data

                    // if request is success
                    if (resData?.success) {
                        setPaymentStatusList(resData?.data) // setting status data
                    }

                    // if request is error
                    if (resData?.error) {
                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500
                        });
                    }
                })();
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getOrderStatusList and getOrderPaymentStatusList`, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            })

            return () => {
                cancelGetOrderStatusListApi && cancelGetOrderStatusListApi()
                cancelGetOrderPaymentStatusListApi && cancelGetOrderPaymentStatusListApi()
            }
        }

    }, [commonToken])

    // on go back press
    const handleBackPress = ev => {
        ev.preventDefault()

        history.goBack() // going back in history
    }

    // when clicked outside
    const handleClickOutside = () => {
        setOrderUpdateDropdown(false) // closing dropdown
        setPaymentStatusDropdown(false) // closing dropdown
        setFullfillmentStatusDropdown(false) // closing dropdown
    }

    // function to update payment status
    const functionToUpdatePaymentStatus = ({ statusCode }) => {
        if (statusCode && currentOrderId) {
            // network request
            updatePaymentStatus(
                commonToken,
                {
                    ...{ orderId: currentOrderId },
                    statusCode
                }
            ).then(res => {
                // page loading
                setPageLoading(false)

                const resData = res?.data

                setPaymentStatusDropdown(false) // setting dropdown to close

                // if request is success
                if (resData?.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(resData?.message ?? "Payment Status updated successfully", {
                        autoClose: 2500
                    });

                    setCurrentPaymentStatus(statusCode) // setting current order status
                }

                // if request is error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updatePaymentStatus`, err.message);

                // page loading
                setPageLoading(false)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            })
        }
    }

    // change payment status
    const handleChangePaymentStatus = (ev, type) => {
        ev.preventDefault()
        if (type) {
            console.log("handleChangePaymentStatus ", type);
            // page loading
            setPageLoading(true)

            const requiredData = {
                statusCode: type
            }

            functionToUpdatePaymentStatus(requiredData) // calling function to update payment status
        }
    }

    // function to update order status
    const functionToUpdateOrderStatus = ({ statusCode, trackingNumber }) => {
        if (statusCode && currentOrderId) {
            // network request
            updateOrderStatus(
                commonToken,
                {
                    ...{ orderId: currentOrderId },
                    statusCode,
                    trackingNumber
                }
            ).then(res => {
                // page loading
                setPageLoading(false)

                const resData = res?.data

                setFullfillmentStatusDropdown(false) // setting dropdown to close

                // if request is success
                if (resData?.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(resData?.message ?? "Status updated successfully", {
                        autoClose: 2500
                    });

                    setCurrentOrderStatus(statusCode) // setting current order status
                }

                // if request is error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updateOrderStatus`, err.message);

                // page loading
                setPageLoading(false)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            })
        }
    }

    // change fullfillment status
    const handleChangeFullfillmentStatus = (ev, type) => {
        ev.preventDefault()
        if (type) {

            if (type === "SHIPPED") { // if type is SHIPPED then open the modal
                setTrackingModalVisibility(true) // opening modal
            } else {
                // page loading
                setPageLoading(true)

                const requiredData = {
                    orderId: currentOrderId,
                    statusCode: type
                }

                functionToUpdateOrderStatus(requiredData) // calling function to update order status
            }
        }
    }

    // setting tracking number
    const setTrackingNumber = number => {
        const statusCode = "SHIPPED"
        const trackingNumber = number ?? ""

        setPageLoading(true) // page loading

        setSelectedTrackingNumber(trackingNumber) // setting tracking number if available

        functionToUpdateOrderStatus({
            statusCode,
            trackingNumber
        }) // calling function to update order status
    }

    // open modal
    const openTrackingModal = ev => {
        ev.preventDefault()

        setTrackingModalVisibility(true) // opening modal
    }
    // close modal
    const closeTrackingModal = () => {
        setTrackingModalVisibility(false) // close modal 
    }

    return (
        <section id="app-salesOrders__edit-details" className="st-def-mar-TB" onClick={handleClickOutside}>
            <Container fluid className="st-container">
                <div className="app-salesOrders__edit-details">
                    {/* back button */}
                    <div className="back-button-wrapper mb-3">
                        <a href="/"
                            className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600"
                            onClick={handleBackPress}>
                            <FeatherIcon
                                icon="arrow-left"
                                size="16"
                                className="icon me-1" />
                            <span>Back to Sales Order</span>
                        </a>
                    </div>

                    <div className="edit-sales-content">
                        <div className="esc-inner d-flex flex-wrap position-relative">
                            {/* ct */}
                            <div className="ct w-100 mb-3">
                                <div className="inner">
                                    <p className="order-id st-text-color">
                                        <span className="d-block">Order #{orderDetails?.orders?.order_id}</span>
                                    </p>
                                    <div className="d-flex">
                                        <a
                                            href="/"
                                            onClick={ev => {
                                                ev.preventDefault()
                                                window.print()
                                            }}
                                            className="st-text-primary hover-underline-link st-fs-14 st-fw-400"
                                        >
                                            <FeatherIcon
                                                icon="printer"
                                                size="13"
                                                className="icon"
                                            />
                                            <span className="ms-2 position-relative" style={{ top: 1 }}>Print Order</span>
                                        </a>

                                        {/* update */}
                                        <div className="sales-order-dropdown position-relative ms-2" onClick={ev => ev.stopPropagation()}>
                                            <a href="/" className="head d-flex hover-underline-link align-items-center text-decoration-none" onClick={ev => {
                                                ev.preventDefault()
                                                setOrderUpdateDropdown(!orderUpdateDropdown)

                                                setFullfillmentStatusDropdown(false) // closing other dropdown
                                                setPaymentStatusDropdown(false) // closing other dropdown
                                            }}>
                                                <span className="me-2">Update</span>
                                                {
                                                    orderUpdateDropdown ? (
                                                        <FeatherIcon
                                                            icon="chevron-up"
                                                            size="16"
                                                            className="icon me-1"
                                                        />
                                                    ) : (
                                                        <FeatherIcon
                                                            icon="chevron-down"
                                                            size="16"
                                                            className="icon me-1"
                                                        />
                                                    )
                                                }
                                            </a>

                                            {
                                                /* dropdown content */
                                                orderUpdateDropdown ? (
                                                    <div className="dropdown-content position-absolute">
                                                        <div className="inner">
                                                            {/* link */}
                                                            <a
                                                                href="/"
                                                                className="link text-decoration-none d-flex"
                                                                onClick={ev => {
                                                                    ev.preventDefault()
                                                                    window.print()
                                                                }}>
                                                                Print Order
                                                            </a>

                                                            {/* link */}
                                                            {/* <a
                                                                href="/"
                                                                className="link text-decoration-none d-flex">
                                                                Send Email
                                                            </a> */}
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* lt sec */}
                            <div className="lt-sec media-body pe-4">
                                <div className="inner">
                                    {/* page border box */}
                                    <div className="page-border-box mb-3">
                                        <div className="pbb-inner">
                                            {/* frac */}
                                            <div className="frac border-bottom d-flex align-items-center pb-3 mb-3">
                                                <div className="lt media-body pe-2">
                                                    <p className="product-date">
                                                        {orderDetails?.orders?.currency_order_amount ?? ""}
                                                        <span className="seprator"></span>
                                                        {orderDetails?.orders?.order_date ?? ""}
                                                    </p>
                                                </div>
                                                {/* <div className="rt">
                                                    <button className="btn st-btn text-capitalize">mark as shipped</button>
                                                </div> */}
                                            </div>

                                            {/* frac */}
                                            <div className="frac d-flex align-items-center">
                                                <div className="lt col-6 col-lg-3">
                                                    <p className="head st-text-color2">Payment Status</p>
                                                    {/* dropdown */}
                                                    <div className="sales-order-dropdown position-relative" onClick={ev => ev.stopPropagation()}>
                                                        {/* head */}
                                                        <p className="desc st-fs-17 st-text-color st-fw-600 d-inline-flex align-items-center cursor-pointer"
                                                            onClick={ev => {
                                                                ev.preventDefault()
                                                                setPaymentStatusDropdown(!paymentStatusDropdown)

                                                                setOrderUpdateDropdown(false) // closing other dropdown
                                                                setFullfillmentStatusDropdown(false) // closing other dropdown
                                                            }}
                                                        >
                                                            <span className="me-2">
                                                                {(
                                                                    paymentStatusList.find(item => item.status_code === currentPaymentStatus)?.status_name ||
                                                                    paymentStatusList.find(item => item.status_code === orderDetails?.orders?.payment_status)?.status_name
                                                                ) ?? ""}
                                                            </span>
                                                            {
                                                                paymentStatusDropdown ? (
                                                                    <FeatherIcon
                                                                        icon="chevron-up"
                                                                        size="16"
                                                                        className="icon me-1"
                                                                    />
                                                                ) : (
                                                                    <FeatherIcon
                                                                        icon="chevron-down"
                                                                        size="16"
                                                                        className="icon me-1"
                                                                    />
                                                                )
                                                            }
                                                        </p>

                                                        {
                                                            /* dropdown content */
                                                            paymentStatusDropdown ? (
                                                                <div className="dropdown-content position-absolute">
                                                                    <div className="inner">
                                                                        {
                                                                            paymentStatusList?.length ? paymentStatusList.map(item => (
                                                                                // link
                                                                                <a
                                                                                    href="/"
                                                                                    key={item.status_code}
                                                                                    className="link text-decoration-none d-flex text-capitalize"
                                                                                    onClick={ev => handleChangePaymentStatus(ev, item.status_code)}>
                                                                                    {item.status_name}
                                                                                </a>
                                                                            )) : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className="rt col-6 col-lg-4 ps-3">
                                                    <p className="head st-text-color2">Fulfillment Status</p>
                                                    {/* dropdown */}
                                                    <div className="sales-order-dropdown position-relative" onClick={ev => ev.stopPropagation()}>
                                                        {/* head */}
                                                        <p className="desc st-fs-17 st-text-color st-fw-600 d-inline-flex align-items-center cursor-pointer" onClick={ev => {
                                                            ev.preventDefault()
                                                            setFullfillmentStatusDropdown(!fullfillmentStatusDropdown) // toggle dropdown

                                                            setOrderUpdateDropdown(false) // closing other dropdown
                                                            setPaymentStatusDropdown(false) // closing other dropdown
                                                        }}>
                                                            <span className="me-2">
                                                                {(
                                                                    orderStatusList.find(item => item.status_code === currentOrderStatus)?.status_name ||
                                                                    orderStatusList.find(item => item.status_code === orderDetails?.orders?.order_status)?.status_name
                                                                ) ?? ""}
                                                            </span>
                                                            {
                                                                fullfillmentStatusDropdown ? (
                                                                    <FeatherIcon
                                                                        icon="chevron-up"
                                                                        size="16"
                                                                        className="icon me-1"
                                                                    />
                                                                ) : (
                                                                    <FeatherIcon
                                                                        icon="chevron-down"
                                                                        size="16"
                                                                        className="icon me-1"
                                                                    />
                                                                )
                                                            }
                                                        </p>

                                                        {
                                                            /* dropdown content */
                                                            fullfillmentStatusDropdown ? (
                                                                <div className="dropdown-content position-absolute">
                                                                    <div className="inner">
                                                                        {
                                                                            orderStatusList?.length ? orderStatusList.map(item => (
                                                                                // link
                                                                                <a
                                                                                    href="/"
                                                                                    key={item.status_code}
                                                                                    className="link text-decoration-none d-flex text-capitalize"
                                                                                    onClick={ev => handleChangeFullfillmentStatus(ev, item.status_code)}>
                                                                                    {item.status_name}
                                                                                </a>
                                                                            )) : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ProductsView
                                        orderDetails={orderDetails}
                                    />

                                    {/* add note view */}
                                    <AddNote
                                        addedNotesList={orderDetails.notes}
                                        addNoteViewVisibility={addNoteViewVisibility}
                                        setAddNoteViewVisibility={setAddNoteViewVisibility}

                                        currentOrderId={currentOrderId}
                                    />

                                    {/* additional info */}
                                    <AdditionalInformation
                                        orderDetails={orderDetails}
                                    />

                                    {/* page border box */}
                                    {/* <div className="page-border-box mb-4">
                                        <div className="pbb-inner">
                                            <p className="head st-fw-600 st-text-color2 st-fs-16 mb-3">Additional information</p>
                                            <p className="st-fs-15 mb-1">IP Address: 72.34.179.202</p>
                                            <p className="st-fs-15 mb-0">Accepts email marketing: No, promo emails not allowed</p>
                                        </div>
                                    </div> */}

                                </div>
                            </div>

                            {/* rt sec */}
                            <div className="rt-sec">
                                <div className="inner">
                                    {/* page border box */}
                                    <div className="page-border-box">
                                        <div className="pbb-inner border-bottom">
                                            {/* frac */}
                                            <div className="frac border-bottom pb-3 mb-3">
                                                <div className="header-container d-flex">
                                                    <div className="in media-body">
                                                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Customer</p>
                                                        <p className="username st-fw-600 st-fs-15 mb-0">
                                                            {orderDetails?.orders?.ship_first_name ?? ""} {orderDetails?.orders?.ship_last_name ?? ""}
                                                        </p>
                                                        <a href="/" className="useremail hover-underline-link st-fs-15">
                                                            {orderDetails?.orders?.email ?? ""}
                                                        </a>
                                                    </div>

                                                    <div className="in ms-auto">
                                                        <a className="st-round-btn st-btn-primary d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/">
                                                            {orderDetails?.orders?.ship_first_name?.charAt(0) + orderDetails?.orders?.ship_last_name?.charAt(0)}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* frac */}
                                            <div className="frac border-bottom pb-3 mb-3">
                                                <div className="header-container d-flex mb-3">
                                                    <div className="in media-body">
                                                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Shipping Details</p>
                                                        <p className="mb-1 st-fs-15">Customer‘s choice: {orderDetails?.orders?.shipping_method ?? ""}</p>
                                                        <p className="mb-1 st-fs-15">Weight: {orderDetails?.orders?.total_weight ?? ""}</p>
                                                        {
                                                            orderDetails?.orders?.tracking_number || selectedTrackingNumber ? ( // if tracking number exist
                                                                <React.Fragment>
                                                                    <a href="/" className="st-text-primary text-decoration-none st-fs-15 d-flex align-items-center mb-1" onClick={openTrackingModal}>
                                                                        <span>{orderDetails.orders.tracking_number || selectedTrackingNumber}</span>
                                                                        <FeatherIcon
                                                                            icon="edit-2"
                                                                            size="13"
                                                                            className="icon ms-2" />
                                                                    </a>

                                                                    <a
                                                                        href={orderDetails?.orders?.tracking_link}
                                                                        target={'_blank'}
                                                                        rel="noreferrer"
                                                                        className="st-text-primary hover-underline-link st-fs-15 d-flex">
                                                                        Track package
                                                                    </a>
                                                                </React.Fragment>
                                                            ) : (
                                                                <a href="/" className="st-text-primary hover-underline-link st-fs-15" onClick={openTrackingModal}>Add tracking number</a>
                                                            )
                                                        }
                                                    </div>

                                                    <div className="in ms-auto">
                                                        <a className="st-round-btn st-btn-transparent d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/">
                                                            <FeatherIcon
                                                                icon="truck"
                                                                size="20"
                                                                className="icon" />
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="header-container d-flex">
                                                    <div className="in media-body">
                                                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Shipping address</p>
                                                        <p className="mb-1 st-fs-15">
                                                            <span>
                                                                {`${orderDetails?.orders?.ship_first_name ?? ""} ${orderDetails?.orders?.ship_middle_name ?? ""} ${orderDetails?.orders?.ship_last_name ?? ""}`}
                                                            </span> <br />
                                                            <span>
                                                                {orderDetails?.orders?.ship_address ?? ""}
                                                            </span> <br />
                                                            {
                                                                orderDetails?.orders?.ship_address1 ? (
                                                                    <React.Fragment>
                                                                        <span>
                                                                            {orderDetails.orders.ship_address1}
                                                                        </span> <br />
                                                                    </React.Fragment>
                                                                ) : null
                                                            }
                                                            <span>
                                                                {orderDetails?.orders?.shipping_city ?? ""}, {orderDetails?.orders?.shipping_state ?? ""}                                                            </span> <br />
                                                            <span>
                                                                {orderDetails?.orders?.ship_zipcode ?? ""} {orderDetails?.orders?.shipping_country ?? ""}
                                                            </span>
                                                        </p>
                                                        {/* <a href="/" className="st-text-primary hover-underline-link st-fs-15">Copy to clipboard</a> <br /> */}
                                                        {/* <a href="/" className="st-text-primary hover-underline-link st-fs-15">
                                                            <span className="me-2">Show on map</span>
                                                            <FeatherIcon
                                                                icon="map-pin"
                                                                size="16"
                                                                className="icon"
                                                            />
                                                        </a> */}
                                                    </div>

                                                    <div className="in ms-auto">
                                                        <a className="st-round-btn st-btn-transparent d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/" style={{ visibility: "hidden", pointerEvents: "none" }}>
                                                            <FeatherIcon
                                                                icon="truck"
                                                                size="20"
                                                                className="icon" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* payment info */}
                                            <PaymentInformation
                                                orderDetails={orderDetails}
                                            />

                                        </div>
                                    </div>

                                </div>
                            </div>

                            {
                                // page loading
                                pageLoading ? (
                                    <div
                                        className="page-loading position-absolute h-100 w-100 d-flex justify-content-center align-items-center"
                                        style={{ top: 0, left: 0, background: 'rgba(255, 255, 255, 0.6)', zIndex: 99 }}>
                                        <Spinner animation="border" />
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </Container>

            {/* modals */}
            <AddTrackingNumberModal
                modalVisibility={trackingModalVisibility}
                closeModal={closeTrackingModal}

                selectedTrackingNumber={orderDetails?.orders?.tracking_number || selectedTrackingNumber}
                setTrackingNumber={number => setTrackingNumber(number)}

                setSelectedTrackingNumber={setSelectedTrackingNumber}

                orderId={currentOrderId}
            />
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditSaleOrder)